import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { LogoCardView } from "./LogoCardView";

export const NotFoundView: React.FC = () => {
    return (
        <LogoCardView>
            <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column", gap: 2 }}>
                <Typography variant="h5" color="text.primary">
                    404 — Page Not Found
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    The page you're looking for doesn't exist.
                </Typography>
                <Typography variant="body2">
                    <Link to="/">Go to Dashboard</Link>
                </Typography>
            </Box>
        </LogoCardView>
    );
};

